export function getSimpleNativePanelsAndTabsRegistry(create) {
    if (create !== false && window.plauditSimpleNativePanelsAndTabs === undefined) {
        return window.plauditSimpleNativePanelsAndTabs = {};
    }
    return window.plauditSimpleNativePanelsAndTabs;
}
export function getSimpleNativePanelsAndTabsForBlock(blockName) {
    return window.plauditSimpleNativePanelsAndTabs?.[blockName];
}
export function getLayeredBlockStylesRegistry(create) {
    if (create !== false && window.plauditLayeredBlockStyles === undefined) {
        return window.plauditLayeredBlockStyles = new Map();
    }
    return window.plauditLayeredBlockStyles;
}
export function getLayeredStylesForBlock(blockName) {
    return window.plauditLayeredBlockStyles?.get(blockName);
}
export function isRootLevelPanelGroup(panelGroup) {
    return panelGroup === undefined || panelGroup === "default" || panelGroup === "advanced" || panelGroup === "settings" || panelGroup === "styles";
}
export function buildDefaultValueFromDefinition(definition) {
    if (definition === undefined) {
        return undefined;
    }
    else if (definition.default !== undefined) {
        return structuredClone(definition.default);
    }
    const typedChildren = Array.isArray(definition.children) ? definition.children : undefined;
    if (!typedChildren?.length) {
        return structuredClone(definition.default);
    }
    else if (definition.type === 'array') {
        return [];
    }
    else if (definition.type !== 'object') {
        return undefined;
    }
    return Object.fromEntries(typedChildren.map(def => [def.name, buildDefaultValueFromDefinition(def)]));
}
//# sourceMappingURL=simple-native-property-internal-shared.js.map